export const customerSuggestions = {
  'default': [
    'How can I improve my productivity?',
    'What are some healthy meal ideas?',
    'Can you help me learn a new skill?',
    'What are the latest technology trends?'
  ]
};

